export class Utils {
  public static searchObjectVal(obj: any, path: string): any {
    const p: Array<string> = path.split('.');
    for (let i = 0, len: number = p.length; i < len; i++) {
      obj = obj[p[i]];
    }
    return obj;
  }

  public static setObjectVal(obj: any, value: any, path: string): any {
    const orgObj: any = obj;
    const p: Array<string> = path.split('.');
    let i: number;
    for (i = 0; i < p.length - 1; i++) {
      obj = obj[p[i]];
    }
    obj[p[i]] = value;
    return orgObj;
  }

  public static findNested(object: any, field: string): any {
    let currentObject: any = object;
    while (currentObject[field] != null) {
      currentObject = currentObject[field];
    }
    return currentObject;
  }

  public static isStagingOrDev(): boolean {
    const hostname = location.hostname;
    return (
      hostname.includes('staging') ||
      hostname.includes('dev') ||
      hostname.includes('localhost')
    );
  }
}
